import React, {memo, useState, useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {useDispatch} from "react-redux";
import {toast} from "react-toastify";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {usePermissionCheck} from "../protectedContent";
import {logout} from "../../service/logout";
import {requestOrganization} from "../../redux/Actions/root.actions";

const NoOrganization = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [open, toggleModal] = useState(true);
  const canViewOrg = usePermissionCheck(["view_organization"]);

  useEffect(() => {
    if (canViewOrg) {
      dispatch(requestOrganization());
    }
  }, [canViewOrg, dispatch]);

  const handleLogout = () => {
    toggleModal(false);
    navigate("/auth/login");
    toast.success("Logged out");
    logout();
  };

  return (
    <Modal unmountOnClose={true} isOpen={open} toggle={toggleModal} backdrop={"static"}>
      <ModalHeader>System Warning</ModalHeader>
      <ModalBody>
        Hello, looks like there is no organization present. Please contact Admin.
      </ModalBody>
      <ModalFooter>
        <Button onClick={handleLogout}>Logout</Button>
      </ModalFooter>
    </Modal>
  );
};

/* eslint-disable no-unused-vars */
function areEqual(prevProps, nextProps) {}

export default memo(NoOrganization, areEqual);
